// src/components/Common/PopupActions.jsx
//
// <PopupActions> — butoanele unui popup din dreapta-sus, lângă „Închide”. Le pune
// rama (PopupUI) în rândul ei de sus, care rămâne lipit sus cât derulezi; popup-ul
// nu mai face loc cu position: absolute. Oriunde în popup:
//
//   <PopupActions>
//      <ButtonUI icon="edit" aria-label="Editează" onClick={…} />
//      <ButtonUI variant="primary" onClick={…}>Salvează</ButtonUI>
//   </PopupActions>
//
// Butoanele neutre devin de sticlă (translucide, cu blur peste conținut). Titlul
// popup-ului își lasă loc la dreapta cu var(--popupUI-bar-w), lățimea rândului.

import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

export const PopupActionsContext = createContext(null);

export default function PopupActions({ children }) {
   const host = useContext(PopupActionsContext);
   if (!host) return null;
   return createPortal(children, host);
}
